import { useCallback, useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import moment from 'moment'
import _ from 'lodash'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextSearch from 'component/Input/InputTextSearch'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import DoctorFeeApi from 'api/setting/doctor-fee-managements/doctor-fee.api'
import { routeName } from 'routes/routes-name'
import { useHistory } from 'react-router-dom'
import { toBuddhistYear } from 'utils/app.utils'
import AlertModal from 'new-components/modal/alert-modal';
import SnackbarComponent from 'new-components/snackbar/snackbar-component';

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}
export default function DoctorFee() {
  const { t } = useTranslation()
  const history = useHistory()

  const [doctorFees, setDoctorFee] = useState([])

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const status = ''

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const loadData = useCallback(async () => {

    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status }

    const res = await DoctorFeeApi.findAll(condition)
    if (res.status === 200) {
      setRowCount(res.headers['x-total'])
      setDoctorFee(res.data)
    }
  }, [page, pageLimit, search, sortBy, sortType, status])

  useEffect(() => {
    loadData()
  }, [loadData])

  const onCreate = () => {
    history.push(routeName.doctorFee + '/create')
  }

  const onActive = () => {
    if (id) {
      DoctorFeeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('DOCTOR_FEE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('DOCTOR_FEE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      DoctorFeeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('DOCTOR_FEE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('DOCTOR_FEE.MESSAGE.ERROR.DEFAULT'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { doctorFeeId } = data
    history.push(`${routeName.doctorFee}/${doctorFeeId}`)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: '#', width: '60px' },
    { id: 'doctorFeeName', disablePadding: false, label: t(`DOCTOR_FEE.FORM.DF_NAME`) },
    { id: 'amount', disablePadding: false, label: t(`DOCTOR_FEE.FORM.DF_CF`), width: '185px' },
    { id: 'dateStart', disablePadding: false, label: t('DOCTOR_FEE.FORM.USE_DATE'), width: '130px' },
    { id: 'templateDoctorFee', disablePadding: false, label: t('DOCTOR_FEE.FORM.TEMPLATE_DF') },
    { id: 'doctors', disablePadding: false, label: t('USER_DOCTOR'), width: '250px' },
    { id: 'status', disablePadding: false, label: t('TABLE.CELL.STATUS'), width: '200px' },
    { id: 'updatedBy', disablePadding: false, label: t('TABLE.CELL.UPDATED_BY'), width: '200px' },
    { id: 'action', disablePadding: false, label: 'Action', width: '80px' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { doctorFeeId, doctorFeeName, amount, dateStart, doctors, status: dfStatus, updatedAt, updatedBy } = objData

    let doctor = doctors ? doctors.split(',') : []
    if (!_.isEmpty(doctor) && _.size(doctor) > 1) doctor = `${doctor[0]} ${t('DOCTOR_FEE.FORM.DOCTOR_AND')} ${_.size(doctor) - 1} ${t('DOCTOR_FEE.FORM.UNIT')}`
    else if (!_.isEmpty(doctor)) doctor = doctor[0]
    else doctor = '-'

    const statusBtnActive = dfStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = dfStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled

    const templateDoctorFeeName = objData.templateDoctorFee ? objData.templateDoctorFee.templateDoctorFeeName : '-'
    const objRenderData = {
      key: doctorFeeId,
      id: doctorFeeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: doctorFeeName, class: 'text-ellipsis' },
        { option: 'TEXT', align: 'left', label: `${amount}:${100 - amount > 0 ? 100 - amount : 0}` },
        { option: 'TEXT', align: 'left', label: toBuddhistYear(moment(dateStart), 'DD/MM/YYYY') },
        { option: 'TEXT', align: 'left', label: templateDoctorFeeName, class: 'text-ellipsis' },
        { option: 'TEXT', align: 'left', label: doctor },
        { option: 'STATUS', align: 'center', label: dfStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.doctorFeeName)
  }

  return (
    <div>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`DOCTOR_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`DOCTOR_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { templateDoctorFeeName: name, status: t(`DOCTOR_FEE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <Card className="border-0 h-100">
        <HeaderCard text={`จัดการค่า DF/LAB`} />
        <Card.Body>
          <Card.Title >
            <Row className="align-items-center">
              <Col sm={8}>
                <Row>
                  <Col md={8} lg={6} xxl={5}>
                    <InputTextSearch
                      keyInput={'search'}
                      label={t('DOCTOR_FEE.TITLE.SEARCH')}
                      value={search}
                      onchange={(event) => {
                        setSearch(event.target.value)
                        setPage(1)
                      }}
                      onClear={(event) => {
                        setSearch('')
                        setPage(1)
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={4} className="mt-2 mt-md-auto">
                <div className="pr-xl-2">
                  <ButtonCustom mode="add" disabled={permissions.isCreate.disabled} onClick={() => onCreate()} textButton={t('DOCTOR_FEE.TITLE.ADD_DF')} className="w-auto ml-auto d-flex mt-auto" />
                </div>
              </Col>
            </Row>
          </Card.Title>

          <div className={'mt-3 pl-xl-3 pr-xl-2'}>
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              sortType={sortType}
              sortBy={sortBy}
              onSort={onRequestSort}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={doctorFees.map((val, i) => {
                return renderData(val, i)
              })}
              tableFixedWidth
              tableMinWidth={1536}
            />
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}
